import { ListItem, Row, Separator, H5 } from '@fs/zion-ui'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getUser } from '../../../services/userService'
import { convertUTCString } from '../../../util/DateUtil'
import { getBooleanDisplayValue, getIdElement } from '../../../util/StringUtil'
import { CisLink } from '../../app/Links'
import DmcDataView from '../../common/DmcDataView'
import { ChatContext } from '../ChatContextProvider'
import ChannelMembersCount from '../common/table/ChannelMembersCount'

export default function ChatSummary() {
  const { t } = useTranslation()
  const { chat } = useContext(ChatContext)
  const [memberData, setMemberData] = useState()

  useEffect(() => {
    if (chat.cisIds) {
      const fetchMemberData = async () => {
        const userResponses = await Promise.allSettled(
          chat.cisIds.map((cisId) => {
            return getUser(cisId, 'cisId')
          })
        )
        const userData = {}
        userResponses.forEach((response) => {
          if (response.status !== 'rejected') {
            userData[response.value.data.identity.users[0].id] = response.value.data.identity.users[0].contactName
          }
        })
        setMemberData(() => userData)
      }
      fetchMemberData()
    }
  }, [chat.cisIds])

  if (!chat.createdByCisId && !chat.type && !chat.createdAtDate) {
    return <H5 supplementary>{t('chat.messages.noMessages', 'No messages found')}</H5>
  }

  const chatDataView = [
    {
      key: 'chat-creator',
      label: t('chat.creatorId', 'Creator ID'),
      detail: chat.createdByCisId.startsWith('cis.user') ? (
        <CisLink userId={chat.createdByCisId} />
      ) : (
        chat.createdByCisId
      ),
    },
    {
      key: 'chat-type',
      label: t('type', 'Type'),
      detail: t(`chat.type.${chat.type}`, chat.type),
    },
    {
      key: 'chat-created',
      label: t('created', 'Created'),
      detail: convertUTCString(chat.createdAtDate, true),
    },
    {
      key: 'chat-description',
      label: t('description', 'Description'),
      detail: chat.description,
    },
    {
      key: 'chat-disabled',
      label: t('disabled', 'Disabled'),
      detail: getBooleanDisplayValue(chat.disabled),
    },
    {
      key: 'chat-updated',
      label: t('updated', 'Updated'),
      detail: convertUTCString(chat.updatedAtDate, true),
    },
  ]

  return (
    <>
      <DmcDataView id="Chat Summary" data={chatDataView} />
      {memberData && (
        <>
          <Separator size="xs" />
          <Row gutters="nano" alignY="middle">
            <H5>{`${t('members', 'Members')}`}</H5>
            <ChannelMembersCount memberCount={chat.memberCount} />
          </Row>
          {Object.entries(memberData).map(([cisId, contactName]) => (
            <ListItem
              id="Chat Channel Member List Item"
              key={cisId}
              primaryText={contactName}
              secondaryText={cisId}
              to={`/user/${getIdElement(cisId)}/summary?context=cisUserId`}
              target="_blank"
            />
          ))}
        </>
      )}
    </>
  )
}
